







































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-stick-progress';

@Component({
  components: {},
})
export default class SwStickProgress extends SwExtendedVue {
  @Prop({ type: Number, default: 0 })
  value: number;

  @Prop({ type: Number, default: 10 })
  max: number;

  @Prop({ type: Boolean, default: false })
  withLabel: boolean;

  @Prop({ type: String, default: utilService.colorConst.selected })
  color: string;

  cssPrefix = cssPrefix;

  /** two digits after point if exist */
  get progressPercentage(): number {
    return Math.floor(this.value * 100 * 100 / this.max) / 100;
  }

  private unitStyle(index: number): CSSStyleOptions {
    return {
      backgroundColor: index <= this.value ? this.color : undefined,
    };
  }
}
